$shm_dashboard_admin_wordstat $mol_page
	title \Wordstat
	body /
		<= Stats $mol_view
			sub /
				<= Regular_tasks $shm_ba_summary_card
					title \Ежедневных задач
					value <= regular_tasks \
				<= Regular_items $shm_ba_summary_card
					title \Ежедневных подзадач
					value <= regular_items \
				<= Daily_requests $shm_ba_summary_card
					title \Запросов к Wordstat с начала суток
					value <= daily_requests \
		<= Settings $shm_dashboard_admin_settings
